import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVButton,
  EVClear,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import SitemapApprovalErrorDialogStyles from './SitemapApprovalErrorDialogStyles';

export const SITEMAP_SERVICE_REQUEST_URL = 'https://www.eagleview.com/service-request';

export const openServiceRequestForm = (event) => {
  // Keep navigation on the clean URL — GTM/GA may decorate href with ?_gl=... on click.
  event.preventDefault();
  globalThis.open(SITEMAP_SERVICE_REQUEST_URL, '_blank', 'noopener,noreferrer');
};

function SitemapApprovalErrorDialog({ open, onClose, onTryAgain }) {
  const classes = SitemapApprovalErrorDialogStyles();

  return (
    <EVDialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialog }}
    >
      <EVDialogTitle className={classes.title}>
        Something went wrong
        <EVClear
          id="sitemap-approval-error-close"
          className={classes.closeButton}
          onClick={onClose}
        />
      </EVDialogTitle>
      <EVDialogContent className={classes.content}>
        <EVDialogContentText className={classes.message}>
          Your structure selections could not be submitted. Please try again.
          <br />
          If this problem persists, please submit this
          {' '}
          <a
            href={SITEMAP_SERVICE_REQUEST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.formLink}
            onClick={openServiceRequestForm}
          >
            web form request
          </a>
          {/* Explicit period after link — Sonar S6772 (ambiguous JSX spacing). */}
          {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
          {'.'}
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions disableSpacing className={classes.actions}>
        <EVButton
          id="sitemap-approval-error-try-again"
          variant="contained"
          color="primary"
          className={classes.tryAgainButton}
          onClick={onTryAgain}
        >
          Try again
        </EVButton>
      </EVDialogActions>
    </EVDialog>
  );
}

SitemapApprovalErrorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTryAgain: PropTypes.func.isRequired,
};

export default SitemapApprovalErrorDialog;
